import translationPL from './translationPL.json'
import translationENG from './translationENG.json'

export const resources = {
    pl: translationPL,
    en: translationENG
}